export const formatMixin = {
    methods: {
        getEV2EBITD(ev, ebitd) {
            let eV = parseFloat(ev);
            let eBitd = parseFloat(ebitd);
            let ratio = (eV/eBitd).toFixed(2);
            if (ratio == "NaN") {
                ratio = "-";
                return ratio;
            }
            if (+ratio < 0) {
                return ratio = "-";
            }
            return ratio;
        },
        
        getFixed(val) {
            let value = +val;
            if (value <= 0) {
                return "-";
            }
            value = value.toFixed(2);
            if (value === "0.00") {
                return "-";
            }
            return value;
        },
        
        getGrowth(val) {
            if (!val) return '0.00%';
            let value = +val;
            value = value.toFixed(2);
            return `${value}%`;
        },
        
        getYield(y) {
            if (!y) return '0.00%';
            let dividend = +y;
            dividend = dividend.toFixed(2);
            dividend = `${dividend}%`;
            return dividend;
        },
        
        getFormat(val) {
            if (!val) {
                val = 'N/A';
                return val;
            }
            let value = +val;
            if (value > 1000000000000) {
                value = (value/1000000000000).toFixed(2);
                value = `${value}T`;
            } else if (value >= 1000000000 && value < 1000000000000) {
                value = (value/1000000000).toFixed(2);
                value = `${value}B`;
            } else if (value >= 10000 && value < 1000000000) {
                value = (value/1000000);
                value = value.toFixed(2);
                value = `${value}M`;
            } else if (value >= 0 && value <= 10000) {
                value = (value/1000000);
                value = value.toFixed(5);
                value = `${value}M`;
            } else if (value < 0 && value > -1000000000) {
                value = (value/1000000).toFixed(2);
                value = `${value}M`;
            } else if (value < 0 && value < -1000000000) {
                value = (value/1000000000).toFixed(2);
                value = `${value}B`;
            } else {
                return value;
            }
            return value;
        },
        
        getForwardPE(p, e) {
            p = `${p}`;
            if (p.includes("C")) {
                p = p.slice(1, p.length)
            }
            let price = +p;
            let eps = +e;
            let forwardPE = (price/eps).toFixed(2);
            if (price && eps > 0) {
                forwardPE = forwardPE;
                return forwardPE;
            } else {
                return forwardPE = "-";
            }
            if(+forwardPE < 0) {
                return forwardPE = "-";
            }
            return forwardPE;
        },
        
        getForwardPEG(p, e) {
            p = `${p}`;
            if (p.includes("C")) {
                p = p.slice(1, p.length)
            }
            let price = +p;
            let eps = +e;
            let forwardPEG = (price/eps).toFixed(2);
            return forwardPEG;
        },
        
        getEV2REV(val) {
            let value = +val;
            if (value < 0) {
                return value = "-";
            }
            value = value.toFixed(2);
            if (value === "NaN") {
                return value = "-";
            }
            return value;
        },
        
        getProjEV2REV(ev, rev) {
            let eValue = parseFloat(ev);
            let projRev = parseFloat(rev);
            let projEV2REV = (eValue/projRev).toFixed(2);
            if (projEV2REV === "NaN") {
                projEV2REV = "-";
                return projEV2REV;
            }
            if (+projEV2REV < 0) {
                projEV2REV = "-";
                return projEV2REV;
            }
            return projEV2REV;
        },
        
        getEV2FCF(val) {
            let value = +val;
            if (value < 0) {
                return value = "-";
            }
            value = value.toFixed(2);
            return value;
        },
        
        getProjEV2FCF(shares_total, cfshr, ev) {
            let shares = parseFloat(shares_total);
            let cfshare = parseFloat(cfshr);
            let projCashFlow = shares * cfshare;
            let enterpriseValue = parseFloat(ev);
            let projEV2FCF = (enterpriseValue/projCashFlow).toFixed(2);
            if (projEV2FCF === "NaN") {
                projEV2FCF = "-";
                return projEV2FCF;
            }
            if (+projEV2FCF < 0) {
                projEV2FCF = "-";
                return projEV2FCF;
            }
            return projEV2FCF;
        },
        
        getRatio(peg) {
            let pegRatio = parseFloat(peg);
            pegRatio = pegRatio.toFixed(2);
            if (+pegRatio <= 0) {
                return pegRatio = "-";
            }
            if (pegRatio === "0.00" || pegRatio === "NaN") {
                return pegRatio = "-";
            }
            return pegRatio;
        },
        
        getFRatio(r, price, eps, geps, ttm) {
            if (+geps <= 0) {
                geps = ttm;
            }
            let forwardPE = this.getForwardPEG(price, eps);
            let ratio = this.getRatio(forwardPE, geps, ttm);
            if (r.frcst_eps == null) {
                return ratio = "-";
            }
            if (ratio === "NaN") {
                return ratio = "-";
            }
            return ratio;
        },
        setExchNI(ni) {
            let income = +ni;
            if (income === 0) {
                return income = "N/A";
            } else if (income >= 1000) {
                income = (income/1000);
                if (income >= 1000) {
                    income = (income/1000);
                    income = income.toFixed(2);
                    return income = `${income}T`;
                }
                income = income.toFixed(2);
                return income = `${income}B`;
            } else if (income > 0 && income < 1000) {
                income = income.toFixed(2);
                return income = `${income}M`;
            } else if (income < 0 && income > -1000) {
                income = income.toFixed(2);
                return income = `${income}M`;
            } else if (income < 0 && income <= -1000) {
                income = (income/1000);
                income = income.toFixed(2);
                return income = `${income}B`;
            } else {
                return income;
            }
        },
        
        setExchPrice(price, rate) {
            if (price && price === 'N/A') return 'N/A';
        
            if (price && price.includes('C')) {
                price = price.replace(/C/g, '');
            }
            if (price && price.includes('H')) {
                price = price.replace(/H/g, '');
            }
            if (price && price.includes(',')) {
                price = price.replace(/,/g, '');
            }
            price = +price;
            let exchPrice = price * rate;
            exchPrice = +exchPrice.toFixed(2);
            exchPrice = exchPrice.toLocaleString("en-US");
            return exchPrice;
        },
        
        setExchRev(val) {
            if (!val) return 'N/A';
            let value = +val;
            value = value * 1000000;
            if (value === 0) {
                return value = "N/A";
            } else if (value > 1000000000000) {
                value = (value/1000000000000).toFixed(2);
                value = `${value}T`;
            } else if (value >= 1000000000 && value < 1000000000000) {
                value = (value/1000000000).toFixed(2);
                value = `${value}B`;
            } else if (value > 0) {
                value = (value/1000000).toFixed(2);
                value = `${value}M`;
            } else if (value < 0) {
                value = (value/1000000).toFixed(2);
                value = `${value}M`;
            } else {
                return value;
            }
            return value;
        },
        formatComp(company) {
            let format = company && company.includes("&amp;") ? company.replace(/&amp;/g, "&") : company;
            return format;
        }
    }
};
